import { EntityState } from '@ngrx/entity';

export interface ICityState extends EntityState<any> {
  loading: boolean;
  loaded: boolean;
  currentCityId: number;
}
